<template>
  <div>
    <div class="row mb-3" v-for="(value, key) in locationOpeningHoursData" :key="key">
      <div class="col-md-4 col-form-label">
         {{$t('po_lc_lb_days_' + key.toLowerCase())}}
      </div>
      <div class="col-md-2">
        <label :for="key + '-start1'" class="form-label">{{ $t('po_lc_lb_start') }}</label>
        <input :id="key + '-start1'" :name="key + '-start1'" type="time" class="form-control" :class="{ 'is-invalid': v$.locationOpeningHoursData.start1.$error }"
               :ref="key + '-start1'" v-model="value.start1">
        <div class="invalid-feedback">{{ v$.locationOpeningHoursData.start1.$errors[0]?.$message }}</div>
      </div>
      <div class="col-md-2">
        <label :for="key + '-end1'" class="form-label">{{ $t('po_lc_lb_end') }}</label>
        <input :id="key + '-end1'" :name="key + '-end1'" type="time" class="form-control" :class="{ 'is-invalid': v$.locationOpeningHoursData.end1.$error }"
               :ref="key + '-end1'" v-model="value.end1">
        <div class="invalid-feedback">{{ v$.locationOpeningHoursData.end1.$errors[0]?.$message }}</div>
      </div>
      <div class="col-md-2">
        <label :for="key + '-start2'" class="form-label">{{ $t('po_lc_lb_start') }}</label>
        <input :id="key + '-start2'" :name="key + '-start2'" type="time" class="form-control" :class="{ 'is-invalid': v$.locationOpeningHoursData.start2.$error }"
               :ref="key + '-start2'" v-model="value.start2">
        <div class="invalid-feedback">{{ v$.locationOpeningHoursData.start2.$errors[0]?.$message }}</div>
      </div>
      <div class="col-md-2">
        <label :for="key + '-end2'" class="form-label">{{ $t('po_lc_lb_end') }}</label>
        <input :id="key + '-end2'" :name="key + '-end2'" type="time" class="form-control" :class="{ 'is-invalid': v$.locationOpeningHoursData.end2.$error }"
               :ref="key + '-end2'" v-model="value.end2">
        <div class="invalid-feedback">{{ v$.locationOpeningHoursData.end2.$errors[0]?.$message }}</div>
      </div>
    </div>

    <div class="mb-3">
      <div class="form-control is-invalid" style="display: none" aria-hidden="true"></div>
      <div class="invalid-feedback d-block" v-if="v$.locationOpeningHoursData.$error">
        {{ v$.locationOpeningHoursData.$errors[0].$message }}
      </div>
    </div>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core'
import { helpers } from '@vuelidate/validators'

const atLeastOneTimeSlot = (value) => {
  // Check if at least one time slot (morning or afternoon) is completely filled
  return Object.values(value).some(day =>
    (day.start1 && day.end1) || (day.start2 && day.end2)
  )
}

export default {
  props: {
    modelValue: Object,
    required: Boolean
  },
  components: {
  },
  setup () {
    return {
      v$: useVuelidate({ $autoDirty: true })
    }
  },
  validations () {
    return {
      locationOpeningHoursData: {
        $custom: this.required
          ? helpers.withMessage(
            () => this.$i18n.t('validations.atLeastOneTimeSlot'),
            atLeastOneTimeSlot
          )
          : { },
        start1: { },
        end1: { },
        start2: { },
        end2: { }
      }
    }
  },
  data: function () {
    return {
      locationOpeningHoursData: {
        MON: { },
        TUE: { },
        WED: { },
        THU: { },
        FRI: { },
        SAT: { },
        SUN: { }
      }
    }
  },
  watch: {
    locationOpeningHoursData: {
      handler: function () {
        // Prepare opening hours
        const newHours = []
        for (const weekday in this.locationOpeningHoursData) {
          const day = this.locationOpeningHoursData[weekday]
          if (day.start1 != null && day.end1 != null) {
            newHours.push({
              weekday,
              start: day.start1,
              end: day.end1
            })
          }
          if (day.start2 != null && day.end2 != null) {
            newHours.push({
              weekday,
              start: day.start2,
              end: day.end2
            })
          }
        }
        this.locationOpeningHours = newHours
      },
      deep: true
    }
  },
  computed: {
    locationOpeningHours: {
      get () {
        return this.modelValue
      },
      set (val) {
        this.$emit('update:modelValue', val)
      }
    }
  }
}
</script>
